export default __webpack_public_path__ + "static/media/sticker-f.79d54dd1.png";